// Per-phone choices for places (docs/PLACES.md), set from the World panel: picked sound files or
// synth only, and the voice that speaks the katakana (Off or Zundamon). Remembered in
// localStorage as a convenience (storage may be unavailable, so never required). Three-free,
// so the World panel can use it from the main bundle.
import { create } from 'zustand'

export type SfxMode = 'mixed' | 'synth'

interface PlacePrefs {
  sfx: SfxMode
  /** A speaker id from the place's voice manifest, or 'off'; null = the manifest's default. */
  voice: string | null
  set(patch: Partial<Pick<PlacePrefs, 'sfx' | 'voice'>>): void
}

const KEY = 'tq-place-prefs'

function read(): Pick<PlacePrefs, 'sfx' | 'voice'> {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<PlacePrefs>
    return { sfx: v.sfx === 'synth' ? 'synth' : 'mixed', voice: typeof v.voice === 'string' ? v.voice : null }
  } catch {
    return { sfx: 'mixed', voice: null }
  }
}

export const usePlacePrefs = create<PlacePrefs>((set, get) => ({
  ...read(),
  set(patch) {
    set(patch)
    try {
      localStorage.setItem(KEY, JSON.stringify({ sfx: get().sfx, voice: get().voice }))
    } catch {
      // ignore
    }
  },
}))
